var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLdl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.1,
    height: 68.1,
    viewBox: "0 0 68.1 68.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_713",
    "data-name": "Trazado 713",
    d: "M24.381,14.141l4.858,4.974H24.381ZM21.2,6.336a2.339,2.339,0,0,0-1.427,2.141v12.94a2.309,2.309,0,0,0,2.3,2.3H34.719a2.31,2.31,0,0,0,2.118-1.4,2.35,2.35,0,0,0-.483-2.51L23.713,6.865a2.284,2.284,0,0,0-1.646-.695,2.345,2.345,0,0,0-.863.165M12.638,7.97v4.974H7.78ZM13.306.695.665,13.635A2.356,2.356,0,0,0,0,15.253v.023a2.22,2.22,0,0,0,.182.869,2.287,2.287,0,0,0,2.118,1.4H14.941a2.309,2.309,0,0,0,2.3-2.3V2.306A2.278,2.278,0,0,0,14.963,0a2.306,2.306,0,0,0-1.657.695",
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.069,
    y1: 0.778,
    x2: 0.079,
    y2: 0.778,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#2deddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#09d3f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ceff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1367",
    "data-name": "Grupo 1367",
    transform: "translate(-970.595 -5326.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975",
    transform: "translate(970.595 5326.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.1,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.1,
    rx: 13.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_984",
    "data-name": "Grupo 984",
    transform: "translate(986.14 5348.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_984-2",
    "data-name": "Grupo 984",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1747",
    "data-name": "Rect\\xE1ngulo 1747",
    width: 42.942,
    height: 42.942,
    transform: "translate(-11.86 11.86) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLdl);
export default __webpack_public_path__ + "static/media/ic_ldl.32de5778e6123123d7b6f48537fb7d26.svg";
export { ForwardRef as ReactComponent };